import { CONTACT, LANGUAGES } from "../../lib/content";
import { Logo } from "./Logo";

export const Footer = () => (
  <footer data-testid="site-footer" className="relative z-10 border-t border-[rgba(28,22,16,0.12)] py-12">
    <div className="max-w-[1600px] mx-auto px-6 md:px-12 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
      <Logo />
      <p className="font-mono text-[10px] tracking-[0.2em] uppercase text-[#4a3e30]">
        {LANGUAGES.join(" · ")}
      </p>
      <p className="font-mono text-[10px] tracking-[0.2em] uppercase text-[#4a3e30]">
        {CONTACT.phone} · abcguitarlessons.com
      </p>
    </div>
  </footer>
);
